import { type JSX, useCallback } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { SchoolProvider } from '@/features/home-manager';
import {
  taskCreationSearchParamsSchema,
  type TaskCreationSearchParams,
  TaskTypeSelectionPage,
} from '@/features/task-creation';
import { useNavigateMerge } from '@/hooks/useNavigateMerge';
import { requireAccess } from '@/permissions';

export const Route = createFileRoute('/tarefa/nova')({
  staticData: { title: 'Criar tarefa de redação' },
  beforeLoad: requireAccess('create:task'),
  validateSearch: (search): TaskCreationSearchParams => taskCreationSearchParamsSchema.parse(search),
  component: NewTaskRoute,
});

function NewTaskRoute(): JSX.Element {
  const { escola } = Route.useSearch();
  const navigate = useNavigateMerge();

  const handleSchoolIdChange = useCallback(
    (schoolId: string) => {
      void navigate({
        to: '.',
        search: { escola: Number(schoolId) },
        replace: true,
      });
    },
    [navigate]
  );

  return (
    <SchoolProvider
      schoolId={escola !== undefined ? String(escola) : null}
      onSchoolIdChange={handleSchoolIdChange}>
      <TaskTypeSelectionPage />
    </SchoolProvider>
  );
}
